import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import API from "../Network/API";
import { clearSession } from "../services/Logout";
import "./Tutor/LiveRoom/LiveRoom.css";
import "./DeleteAccount.css";

// xller.com/delete-account: the public account-deletion page the app stores link to.
// Signed-in users confirm with their password; the backend anonymises the account.
export default function DeleteAccount() {
    const { t } = useTranslation();
    const location = useLocation();
    const { user, accessToken } = useSelector((state) => state.authReducer);
    const prefix = location.pathname.startsWith("/app") ? "/app" : "";
    const [password, setPassword] = useState("");
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState("");
    const [done, setDone] = useState(false);

    const submit = (e) => {
        e.preventDefault();
        if (!password) return setError(t("deleteAccount.password_required"));
        if (!window.confirm(t("deleteAccount.confirm"))) return;
        setBusy(true);
        setError("");
        API.delete("/v1/oauth/account", { data: { password } })
            .then(() => { clearSession(); setDone(true); })
            .catch((err) => setError(err?.response?.data?.errors?.password?.[0] || err?.response?.data?.message || t("deleteAccount.failed")))
            .finally(() => setBusy(false));
    };

    const points = [
        t("deleteAccount.point_profile"),
        t("deleteAccount.point_signin"),
        user?.role === "teacher" ? t("deleteAccount.point_tutor") : t("deleteAccount.point_lessons"),
        t("deleteAccount.point_records"),
    ];

    return (
        <div className="lj-page container">
            <div className="lj-card da-card">
                {done ? (
                    <>
                        <i className="fa-light fa-circle-check lj-icon" />
                        <h4>{t("deleteAccount.done_title")}</h4>
                        <p>{t("deleteAccount.done_text")}</p>
                        <a href={prefix || "/"} className="btn lr-btn-primary">{t("deleteAccount.home")}</a>
                    </>
                ) : (
                    <>
                        <i className="fa-light fa-user-xmark lj-icon da-icon" />
                        <h4>{t("deleteAccount.title")}</h4>
                        <p>{t("deleteAccount.intro")}</p>
                        <ul className="da-points">
                            {points.map((point) => <li key={point}>{point}</li>)}
                        </ul>
                        {accessToken ? (
                            <form onSubmit={submit} className="da-form">
                                <label htmlFor="da-password">{t("deleteAccount.password_label")}</label>
                                <input id="da-password" type="password" className="form-control" autoComplete="current-password"
                                    value={password} onChange={(e) => setPassword(e.target.value)} />
                                {error && <div className="da-error">{error}</div>}
                                <button type="submit" className="btn da-danger" disabled={busy}>
                                    {busy ? t("deleteAccount.deleting") : t("deleteAccount.cta")}
                                </button>
                            </form>
                        ) : (
                            <div className="lj-actions">
                                <Link to={`${prefix}/login?redirect=${encodeURIComponent(`${prefix}/delete-account`)}`} className="btn lr-btn-primary">
                                    {t("deleteAccount.sign_in")}
                                </Link>
                            </div>
                        )}
                        <p className="da-help">{t("deleteAccount.help", { email: "info@xller.com" })}</p>
                    </>
                )}
            </div>
        </div>
    );
}
